import { useEffect } from 'react';

import { useAppSelector } from '@fd/customHooks/useAppSelector';
import { useHistory, useLocation } from 'react-router-dom';

import { useHasAccessToOnboardingV3 } from '../components/OnboardingV3/hooks/useHasAccessToOnboardingV3';

export const RedirectClientToOnboardingV3 = () => {
  const history = useHistory();
  const location = useLocation();
  const currentApp = useAppSelector((state) => state.currentApp);
  // can't access params here because it's not available in the router yet
  const appId = location.pathname.split('/')[1];

  const { reducedOnboardingView, onboardingWaitingView, permissionsLoaded } =
    useHasAccessToOnboardingV3();

  useEffect(() => {
    const appReady = permissionsLoaded && appId && appId === currentApp?.AppId;

    if (
      appReady &&
      reducedOnboardingView &&
      !location.pathname.includes('/setup') &&
      !location.pathname.includes('/profile')
    ) {
      history.replace(`/${appId}/setup`);
      return;
    }

    if (
      appReady &&
      onboardingWaitingView &&
      !location.pathname.includes('/home') &&
      !location.pathname.includes('/profile')
    ) {
      history.replace(`/${appId}/home`);
    }
  }, [
    permissionsLoaded,
    reducedOnboardingView,
    onboardingWaitingView,
    location.pathname,
    appId,
    history,
    currentApp?.AppId,
  ]);

  return null;
};

export default RedirectClientToOnboardingV3;
